"use client";

import * as Api from "@api";
import React from "react";

interface PageContentToClipboardProps<Mode extends Api.DBContentMode, DBContent extends Api.AbstractDBContent<Mode>[], Keys extends readonly Api.ContentKey[]>
{
    keys: Keys;
    dbContent: DBContent;
}

export const PageContentToClipboard = <Mode extends Api.DBContentMode, DBContent extends Api.AbstractDBContent<Mode>[], Keys extends readonly Api.ContentKey[]>({ dbContent, keys }: PageContentToClipboardProps<Mode, DBContent, Keys>): React.FunctionComponentElement<PageContentToClipboardProps<Mode, DBContent, Keys>> =>
{
    const copyToClipboard = async () =>
    {
        const text = Api.ContentService.getJS(dbContent, keys);
        await navigator.clipboard.writeText(text);
    };

    return (
        <button onClick={copyToClipboard} type="button">
            Copy page content to clipboard
        </button>
    );
};